var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.2,11.03l-7.5,8.52c-.32,.36-.75,.56-1.23,.56-.49,0-.91-.19-1.23-.56l-1.17-1.09-1.35,1.53c-.32,.36-.75,.56-1.23,.56h0c-.49,0-.91-.19-1.23-.56l-3.47-3.96c-.22-.25-.19-.63,.06-.85s.63-.19,.85,.06l3.47,3.96c.09,.1,.19,.15,.33,.15h0c.14,0,.24-.05,.33-.15l7.5-8.52c.22-.25,.6-.27,.85-.05,.25,.22,.27,.6,.05,.85l-5.36,6.09s.02,0,.02,.01l1.22,1.14c.26,.29,.52,.25,.71,.04l7.5-8.52c.22-.25,.6-.27,.85-.05,.25,.22,.27,.6,.05,.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidated);
export default __webpack_public_path__ + "static/media/liquidated.216cf8c154cd7d836cee5174bedc99e4.svg";
export { ForwardRef as ReactComponent };